import { Button, Form, Input, Modal, Table, Typography } from 'antd';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { FileAddOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { formatPhoneNumber, formatMobileNumber } from 'utils/helper';
import { deleteDelDtl, getCustomerDelDetails } from 'services/customers/customers';
import { reduce } from 'lodash';

const EditableContext = React.createContext(null);

const EditableRow = ({ index, ...props }) => {
	const [form] = Form.useForm();
	return (
		<Form form={form} component={false}>
			<EditableContext.Provider value={form}>
				<tr {...props} />
			</EditableContext.Provider>
		</Form>
	);
};

const EditableCell = ({
	title,
	editable,
	children,
	dataIndex,
	record,
	handleSave,
	...restProps
}) => {
	const [editing, setEditing] = useState(false);
	const inputRef = useRef(null);
	const form = useContext(EditableContext);
	useEffect(() => {
		if (editing) {
			inputRef.current.focus();
			inputRef.current.select();
		}
	}, [editing]);

	const toggleEdit = () => {
		setEditing(!editing);
		form.setFieldsValue({
			[dataIndex]: record[dataIndex],
		});
	};

	const save = async () => {
		try {
			const values = await form.validateFields();
			toggleEdit();
			handleSave({ ...record, ...values });
		} catch (errInfo) {
			console.log('Save failed:', errInfo);
		}
	};

	const handleInputChange = ({ e, dataIndex }) => {
		switch (dataIndex) {
			case 'tel_no':
				form.setFieldsValue({ [dataIndex]: formatPhoneNumber(e.target.value) });
				break;
			case 'mobile_no':
				form.setFieldsValue({ [dataIndex]: formatMobileNumber(e.target.value) });
				break;
			default:
				form.setFieldsValue({ [dataIndex]: e.target.value });
		}
	};

	let childNode = children;
	if (editable) {
		if (dataIndex === 'location_name') {
			childNode = editing ? (
				<Form.Item
					style={{
						margin: 0,
					}}
					name={dataIndex}
					rules={[
						{
							required: true,
							message: 'Required Field',
						},
					]}
				>
					<Input ref={inputRef} onPressEnter={save} onBlur={save} maxLength={50} />
				</Form.Item>
			) : (
				<div
					className="editable-cell-value-wrap"
					style={{
						paddingRight: 24,
						wordBreak: 'break-word',
					}}
					onClick={toggleEdit}
				>
					{children}
				</div>
			);
		} else if (dataIndex === 'delivery_address') {
			childNode = editing ? (
				<Form.Item
					style={{
						margin: 0,
					}}
					name={dataIndex}
					rules={[
						{
							required: true,
							message: 'Required Field',
						},
					]}
				>
					<Input ref={inputRef} onPressEnter={save} onBlur={save} maxLength={200} />
				</Form.Item>
			) : (
				<div
					className="editable-cell-value-wrap"
					style={{
						paddingRight: 24,
						wordBreak: 'break-word',
					}}
					onClick={toggleEdit}
				>
					{children}
				</div>
			);
		} else if (dataIndex === 'contact_person') {
			childNode = editing ? (
				<Form.Item
					style={{
						margin: 0,
					}}
					name={dataIndex}
					// rules={[
					// 	{
					// 		required: true,
					// 		message: 'Required Field',
					// 	},
					// ]}
				>
					<Input ref={inputRef} onPressEnter={save} onBlur={save} maxLength={50} />
				</Form.Item>
			) : (
				<div
					className="editable-cell-value-wrap"
					style={{
						paddingRight: 24,
						wordBreak: 'break-word',
					}}
					onClick={toggleEdit}
				>
					{children}
				</div>
			);
		} else if (dataIndex === 'tel_no') {
			childNode = editing ? (
				<Form.Item
					style={{
						margin: 0,
					}}
					name={dataIndex}
				>
					<Input ref={inputRef} onPressEnter={save} onBlur={save} maxLength={50} />
				</Form.Item>
			) : (
				<div
					className="editable-cell-value-wrap"
					style={{
						paddingRight: 24,
					}}
					onClick={toggleEdit}
				>
					{children}
				</div>
			);
		} else if (dataIndex === 'mobile_no') {
			childNode = editing ? (
				<Form.Item
					style={{
						margin: 0,
					}}
					name={dataIndex}
				>
					<Input ref={inputRef} onPressEnter={save} onBlur={save} maxLength={50} />
				</Form.Item>
			) : (
				<div
					className="editable-cell-value-wrap"
					style={{
						paddingRight: 24,
					}}
					onClick={toggleEdit}
				>
					{children}
				</div>
			);
		} else
			childNode = editing ? (
				<Form.Item
					style={{
						margin: 0,
					}}
					name={dataIndex}
					rules={[
						{
							required: true,
							message: 'Required Field',
						},
					]}
				>
					<Input
						ref={inputRef}
						onPressEnter={save}
						onBlur={save}
						// style={ {textTransform: "uppercase"} }
						onChange={e => {
							handleInputChange({ e, dataIndex });
						}}
					/>
				</Form.Item>
			) : (
				<div
					className="editable-cell-value-wrap"
					onClick={toggleEdit}
					// style={ {textTransform: "uppercase"} }
				>
					{children}
				</div>
			);
	}

	return <td {...restProps}>{childNode}</td>;
};

function DeleveryAddTable(props) {
	const { data } = props;

	const [dataSource, setDataSource] = useState([]);
	const customeDelProps = props.dataDelAdd === 'undefined' ? '' : props.dataDelAdd;
	const [linesForDelete, setLinesForDelete] = useState([]);
	const [count, setCount] = useState(2);
	const [initData, setInitData] = useState([]);

	useEffect(() => {
		props.onSubmit(dataSource);
		// props.touchedBillAdd(true);
	}, [dataSource]);

	useEffect(() => {
		props.forDeleteDelivery(linesForDelete);
	}, [linesForDelete]);

	useEffect(() => {
		props.getInitData(initData);
	}, [initData]);

	useEffect(() => {
		if (props.isEditting) {
			async function fetchData() {
				if (props.isEditting) {
					const getCustomer_id = {
						customer_id: customeDelProps.customer_id,
					};

					const CustomerDelDetails = await getCustomerDelDetails(getCustomer_id);
					setDataSource(CustomerDelDetails);
					setInitData(CustomerDelDetails);
				}
			}
			fetchData();
		}
	}, []);

	const handleSubmit = () => {
		props.touchedBillAdd(true);
	};

	const handleDeleteLine = key => {
		const newData = dataSource.filter(item => item.delivery_address_id !== key.delivery_address_id);
		setDataSource(newData);
		setLinesForDelete(linesForDelete.concat(key.delivery_address_id));
	};

	const Astrx = <span style={{color: "red", fontSize: 20, fontWeight: 'bold'}}>*</span>;

	const defaultColumns = [
		{
			title: <div>{Astrx}BUSINESS NAME</div>,
			dataIndex: 'location_name',
			key: 'location_name',
			editable: !props.disabled,
			width: '15%',
			overflow: 'auto',
		},
		{
			title: <div>{Astrx}ADDRESS</div>,
			dataIndex: 'delivery_address',
			key: 'delivery_address',
			editable: !props.disabled,
			width: '25%',
		},
		{
			title: 'CONTACT PERSON',
			dataIndex: 'contact_person',
			key: 'contact_person',
			editable: !props.disabled,
			width: '20%',
		},
		{
			title: 'TEL. NO.',
			dataIndex: 'tel_no',
			key: 'tel_no',
			editable: !props.disabled,
			width: '15%',
		},
		{
			title: 'MOBILE NO.',
			dataIndex: 'mobile_no',
			key: 'mobile_no',
			editable: !props.disabled,
			width: '15%',
		},
		{
			title: 'OPERATION',
			dataIndex: 'del_operation',
			width: '5%',
			render: (_, record) =>
				dataSource.length >= 1 ? (
					// eslint-disable-next-line jsx-a11y/anchor-is-valid
					<Typography.Link style={{textTransform: 'capitalize'}} onClick={() => handleDeleteLine(record)}
						disabled={props.disabled}
					>DELETE</Typography.Link>
				) : null,
		},
	];

	const handleAdd = () => {
		const newData = {
			// key: count,
			location_name: '-',
			delivery_address_id: count,
			delivery_address: '-',
			contact_person: '-',
			tel_no: '(632)XXXX-YYYY',
			mobile_no: '(639)XX-XXX-YYYY',
		};
		setDataSource([...dataSource, newData]);
		setCount(count + 1);
	};

	function sendNewData(val){
		props.sendNewDel(val);
	}

	const handleSave = row => {
		const newData = [...dataSource];
		const index = newData.findIndex(item => row.delivery_address_id === item.delivery_address_id);
		const item = newData[index];
		newData.splice(index, 1, { ...item, ...row });

		// check existing lines with the same location_name of the current row
		const tblDataRet = newData.filter(
			items => items.delivery_address === (row.delivery_address === undefined ? '' : row.delivery_address),
		);

		if (tblDataRet.length > 1 && row.delivery_address !== '-') {
			console.log('Not allowed to Input same address')
		} else {
			setDataSource(newData);
			handleSubmit();
			sendNewData(newData);
		}
      
	};

	const components = {
		body: {
			row: EditableRow,
			cell: EditableCell,
		},
	};

	const columns = defaultColumns.map(col => {
		if (!col.editable) {
			return col;
		}

		return {
			...col,
			onCell: record => ({
				record,
				editable: col.editable,
				dataIndex: col.dataIndex,
				title: col.title,
				handleSave,
			}),
		};
	});

	return (
		<div>
			<Button
				onClick={handleAdd}
				style={{
					marginTop: 20,
				}}
				icon={<FileAddOutlined />}
				disabled={props.disabled}
			>
				DELIVERY ADDRESS
			</Button>
			<Table
				rowKey={record => record.delivery_address_id}
				style={{ textTransform: 'uppercase' }}
				components={components}
				rowClassName={() => 'editable-row'}
				bordered
				dataSource={dataSource}
				columns={columns}
				pagination={{ defaultPageSize: 5 }}
			/>
		</div>
	);
}

export default DeleveryAddTable;
